import React from 'react';

const Title = ({ text, classNames }) => {
  return <h2 className={`text-28 ${classNames}`}>{text}</h2>;
};

export default Title;
